import React from "react";
import styled from "styled-components";
import imgCar from "../../assets/images/img_car.gif";

const StyledDiv = styled.div`
  &&& {
    background: url(${imgCar}) center no-repeat;
    background-size: 140px;
    width: 620px;
    height: 100%;
    position: relative;
    margin: 0 auto;

    dl {
      position: absolute;
    }

    dd {
      font-size: 34px;
    }

    .p_fl {
      left: 75px;
      bottom: 225px;
      padding-left: 42px;

      &:after {
        content: "";
        position: absolute;
        left: 0;
      }
    }

    .p_fr {
      right: 75px;
      bottom: 225px;
      padding-right: 42px;
    }

    .p_rl {
      left: 75px;
      bottom: 60px;
      padding-left: 42px;

      &:after {
        content: "";
        position: absolute;
        left: 0;
      }
    }

    .p_rr {
      right: 75px;
      bottom: 60px;
      padding-right: 42px;
    }
  }
`;

const PressureDiv = ({ className, children }) => {
  return <StyledDiv className={className}>{children}</StyledDiv>;
};

export default PressureDiv;
